import { IFIReportType } from 'shared'
import { CIMSCollapsePanelOptions } from 'components/CIMSCollapse/types'
import { NestedCollapseProps } from '../common'
import { useProjectSettingsContext } from '../../../../ProjectSettingsContext'
import { DensityLotPanelName } from './types'
import { useState } from 'react'
import DirtyHeader from '../../components/DirtyHeader'
import EnabledIndicator from '../../components/EnabledIndicator'
import DensityLotViewPanel from './components/DensityLotViewPanel'
import DensityLotEditPanel from './components/DensityLotEditPanel'

const useDensityLotPanel = (
  collapseProps: NestedCollapseProps
): CIMSCollapsePanelOptions => {
  const {
    lotIFISettings: { data },
    canEdit,
  } = useProjectSettingsContext()
  const [dirtyPanels, setDirtyPanels] = useState<DensityLotPanelName[]>([])

  return {
    header: {
      children: (
        <DirtyHeader
          title={IFIReportType.Lot.type}
          isDirty={dirtyPanels.length > 0}
        />
      ),
    },
    key: IFIReportType.Lot.id,
    extra: {
      children: <EnabledIndicator enabled={data?.enabled} />,
    },
    children: canEdit ? (
      <DensityLotEditPanel
        {...{ dirtyPanels, setDirtyPanels, ...collapseProps }}
      />
    ) : (
      <DensityLotViewPanel />
    ),
  }
}

export default useDensityLotPanel
